var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camera_Icon",
    "data-name": "Camera Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 141.33,
    height: 141.33,
    viewBox: "0 0 141.33 141.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_497560",
    "data-name": "Path 497560",
    d: "M76.391,59.616a17.6,17.6,0,1,1-17.6-17.872A17.751,17.751,0,0,1,76.391,59.616Zm-41.56-46.2A13.142,13.142,0,0,1,46.621,6H70.965a13.142,13.142,0,0,1,11.79,7.417l5.162,10.455h6.071a17.751,17.751,0,0,1,17.6,17.872v44.68a17.751,17.751,0,0,1-17.6,17.872H23.6A17.751,17.751,0,0,1,6,86.424V41.744A17.751,17.751,0,0,1,23.6,23.872h6.071Zm50.359,46.2a26.4,26.4,0,1,0-26.4,26.808A26.607,26.607,0,0,0,85.189,59.616Z",
    transform: "translate(11.872 11.872)",
    fill: "#356F92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_497561",
    "data-name": "Path 497561",
    d: "M0,0H141.33V141.33H0Z",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.910c08e22c69ef00f15586c782b708c0.svg";
export { ForwardRef as ReactComponent };